import { render, staticRenderFns } from "./RmrPagination.vue?vue&type=template&id=086298e6&scoped=true&"
import script from "./RmrPagination.vue?vue&type=script&lang=js&"
export * from "./RmrPagination.vue?vue&type=script&lang=js&"
import style0 from "./RmrPagination.vue?vue&type=style&index=0&id=086298e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086298e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
